import { gql } from '@apollo/client'

export const SEND_INVOICE_MUTATION = gql`
  mutation sendInvoice($processingId: ID!) {
    sendInvoice(processingId: $processingId) {
      id
    }
  }
`
